import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { CheckboxInput, TextInput } from '@guildeducationinc/recess';
import { FEE_TYPES } from '@src/graphql/queries/feeType';
import { useLocale } from 'pe-core-frontend';
import { useCallback, useEffect, useMemo } from 'react';
import { MuiMultiSelect } from 'pe-core-frontend';
const EXPENSE_TYPE_CONFIG = [
    { key: 'courses', allowKey: 'allowCourses', payoutKey: 'coursesPayoutPct', labelKey: 'expenseOption.allowCourses' },
    { key: 'books', allowKey: 'allowBooks', payoutKey: 'booksPayoutPct', labelKey: 'expenseOption.allowBooks' },
    {
        key: 'materials',
        allowKey: 'allowMaterials',
        payoutKey: 'materialsPayoutPct',
        labelKey: 'expenseOption.allowMaterials',
    },
    { key: 'fees', allowKey: 'allowFees', payoutKey: 'feesPayoutPct', labelKey: 'expenseOption.allowFees' },
];
const SIMPLE_TYPES = ['allowScholarships'];
export const ExpensePolicy = ({ policy, onChange, readonly, errors, getValidationErrors, }) => {
    const { t } = useLocale();
    const { data: feeTypesData } = useQuery(FEE_TYPES);
    const feeTypeOptions = useMemo(() => {
        return (feeTypesData?.feeTypes || []).map((feeType) => ({
            value: feeType.id,
            label: feeType.name,
        }));
    }, [feeTypesData]);
    const validatePolicy = useCallback(() => {
        const errs = {};
        for (const { allowKey, payoutKey, labelKey } of EXPENSE_TYPE_CONFIG) {
            if (policy[allowKey] && policy[payoutKey] === undefined) {
                errs[payoutKey] = t('expenseOption.payoutRequired', { values: { label: t(labelKey) } });
            }
        }
        if (policy.allowFees && policy.allowFeeTypes && !policy.feeTypes?.length) {
            errs.feeTypes = t('expenseOption.feeTypeRequired');
        }
        return errs;
    }, [policy, t]);
    useEffect(() => {
        if (getValidationErrors) {
            getValidationErrors.current = validatePolicy;
        }
    }, [getValidationErrors, validatePolicy]);
    return (_jsxs("div", { className: 'flex flex-col gap-2', children: [SIMPLE_TYPES.map(key => (_jsx(CheckboxInput, { label: t(`expenseOption.${key}`), checked: policy[key] ?? false, onChange: e => onChange({ ...policy, [key]: e.currentTarget.checked }), disabled: readonly }, key))), EXPENSE_TYPE_CONFIG.map(({ key, allowKey, payoutKey, labelKey }) => (_jsxs("div", { className: 'flex flex-col gap-1', children: [_jsxs("div", { className: 'flex items-center gap-4', children: [_jsx(CheckboxInput, { label: t(labelKey), checked: policy[allowKey] ?? false, onChange: e => onChange({ ...policy, [allowKey]: e.currentTarget.checked }), disabled: readonly }), policy[allowKey] && (_jsx(_Fragment, { children: !readonly ? (_jsx(TextInput, { label: '', append: '%', type: 'number', min: '0', max: '100', step: '1', value: policy[payoutKey] ?? '', errors: errors?.[payoutKey], onChange: e => {
                                        const val = e.target.value;
                                        const num = Number(val);
                                        onChange({
                                            ...policy,
                                            [payoutKey]: val === '' || isNaN(num) ? undefined : Math.min(100, Math.max(0, num)),
                                        });
                                    } })) : (_jsx("span", { children: policy[payoutKey] !== undefined ? `${policy[payoutKey]}%` : 'Not set' })) }))] }), key === 'fees' && policy.allowFees && (_jsxs("div", { className: 'ml-8 flex flex-col gap-2', children: [_jsx(CheckboxInput, { label: t('Fee Types?'), checked: policy.allowFeeTypes ?? true, onChange: e => onChange({ ...policy, allowFeeTypes: e.currentTarget.checked }), disabled: readonly }), _jsx(MuiMultiSelect, { label: t('Fees'), hideLabel: true, value: policy.feeTypes || [], onChange: e => onChange({ ...policy, feeTypes: e.target.value }), options: feeTypeOptions, disabled: readonly, errors: errors?.feeTypes })] }))] }, key)))] }));
};
